export default function navAccordion() {
  if (window.innerWidth >= 1024) return;
  
  const menuFooter = document.querySelector('.site-footer__menu');
  const entryTitles: NodeListOf<HTMLElement> = menuFooter?.querySelectorAll('.menu-item-has-children');

  entryTitles && entryTitles.forEach(entry => {
    const submenu = entry?.querySelector('.sub-menu') as HTMLElement;
    const submenuHeight = submenu.offsetHeight.toString();
    const otherEntries = entryTitles;

    submenu.style.height = '0';
    if (entry === entryTitles[0]) {
      submenu.style.height = `${submenuHeight}px`;
      entry.classList.add('is-open');

    }

    entry.addEventListener('click', event => {
      event.preventDefault();

      if (entry.classList.contains('is-open')) {
        submenu.style.height = '0';
        entry.classList.remove('is-open')
      } else {
        submenu.style.height = `${submenuHeight}px`;
        entry.classList.add('is-open')
      }

      otherEntries.forEach(otherEntry => {
        if (otherEntry !== entry && otherEntry.classList.contains('is-open')) {
          const openSubmenu = otherEntry.querySelector('.sub-menu') as HTMLElement;
          otherEntry.classList.remove('is-open');
          openSubmenu.style.height = '0';
        }
      })

    })
  })
}